// @flow
import { APICore } from './apiCore';
import config from '../../config';
import { PAGINATION_DEFAULT_VALUE } from '../defaultValue';

const api = new APICore();

function getCsvMapping(file, destinationFields) {
    const baseUrl = `${config.INTEGRATIONS_URL}/templates/get_mapping`;
    const formData = { file: file, destinationFields: destinationFields };
    return api.createWithFile(baseUrl, formData);
}

function getAllIntegrations(query: Query): any {
    const page = query.currentPage || PAGINATION_DEFAULT_VALUE.currentPage;
    const page_size = query.pageSize || PAGINATION_DEFAULT_VALUE.pageSize;

    let baseUrl = config.INTEGRATIONS_URL;

    if (typeof query === 'string') {
        baseUrl += `?${query}`;
    }

    const queryParam = {
        page: page.toString(),
        page_size: page_size.toString(),
    };

    return api.get(`${baseUrl}`, typeof query === 'object' ? queryParam : undefined, {});
}

function createIntegration(integration: any): any {
    const baseUrl = config.INTEGRATIONS_URL;
    return api.create(`${baseUrl}`, integration);
}

function integrationFileUpload(integrationId: string, fileFormData: string): any {
    const baseUrl = config.INTEGRATIONS_URL + '/' + integrationId + '/' + 'file';
    return api.createWithFile(`${baseUrl}`, fileFormData);
}

function downloadIntegrationFile(integrationId: string, filename: string): any {
    const baseUrl = `${config.INTEGRATIONS_URL}/${integrationId}/file/download`;
    return api.getFile(baseUrl, { filename });
}

function getAllIntegrationErrors(integrationId: string, query: Query): any {
    const page = query?.currentPage - 1 || PAGINATION_DEFAULT_VALUE.currentPage - 1;
    const page_size = query?.pageSize || PAGINATION_DEFAULT_VALUE.pageSize;

    let baseUrl = `${config.INTEGRATIONS_URL}/${integrationId}/integration_errors`;

    if (typeof query === 'string') {
        baseUrl += `?${query}`;
    }

    const queryParam = {
        page: page.toString(),
        page_size: page_size.toString(),
    };

    return api.get(`${baseUrl}`, typeof query === 'object' ? queryParam : undefined, {
        headers: { 'full-response': true },
    });
}

function getAllImportTemplates(type): any {
    const baseUrl = `${config.INTEGRATIONS_URL}/templates`;
    return api.get(`${baseUrl}`, {
        type,
    });
}

function createImportTemplate(template, type): any {
    const baseUrl = `${config.INTEGRATIONS_URL}/templates`;
    return api.create(`${baseUrl}`, template, { params: { type } });
}

function exportImportTemplate(templateId, type): any {
    const baseUrl = `${config.INTEGRATIONS_URL}/templates/${templateId}/export`;
    return api.get(`${baseUrl}`, {
        type,
    });
}

function deleteIntegration(integrationId: string): any {
    const baseUrl = `${config.INTEGRATIONS_URL}/${integrationId}`;
    return api.delete(`${baseUrl}`);
}

export {
    getCsvMapping,
    getAllIntegrations,
    createIntegration,
    integrationFileUpload,
    downloadIntegrationFile,
    getAllImportTemplates,
    createImportTemplate,
    exportImportTemplate,
    getAllIntegrationErrors,
    deleteIntegration,
};
